const state = {
  reservation: null,
  task: null,
  worker: null,
  invalidReservation: [],
  reservationRejected: null,
  taskRejected: null
}

const getters = {
  getReservation (state) {
    return state.reservation
  },
  task (state) {
    return state.task
  },
  worker (state) {
    return state.worker
  },
  invalidReservation (state) {
    return state.invalidReservation
  },
  reservationRejected (state) {
    return state.reservationRejected
  },
  taskRejected (state) {
    return state.taskRejected
  }
}

const mutations = {
  SET_RESERVATION (state, reservation) {
    state.reservation = reservation
  },
  REMOVE_RESERVATION (state) {
    state.reservation = null
  },
  SET_TASK (state, task) {
    state.task = task
  },
  RESET_WORKSPACE (state) {
    state.reservation = null
    state.task = null
  },
  SET_WORKER (state, worker) {
    state.worker = worker
  },
  RESET_WORKER (state) {
    state.worker = null
  },
  PUSH_INVALID_RESERVATION (state, reservationSid) {
    state.invalidReservation.push(reservationSid)
  },
  REMOVE_INVALID_RESERVATION (state, reservationSid) {
    state.invalidReservation = state.invalidReservation.filter(sid => sid !== reservationSid)
  },
  RESET_INVALID_RESERVATION (state) {
    state.invalidReservation = []
  },
  SET_RESERVATION_REJECTED (state, reservation) {
    state.reservationRejected = reservation
  },
  SET_TASK_REJECTED (state, task) {
    state.taskRejected = task
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
